<template>
    <el-dialog class="ttl-box" v-model="logview" width="20%" title="商品置顶退款" :before-close="handleClose">
        <el-form :inline="false">
            <el-form-item>
                <label class="TTL-form-label">首页可退订时间（天）</label>
                <wcinput 
                    :option="{title:'请填写退订时间',type:'input',width:'100%',isinput:true}" 
                    :value="refundinfo.endtime"  
                    @finish="(val)=> {
                        this.refundinfo.endtime=val.value;
                    }"
                />
            </el-form-item>
            <el-form-item>
                <label class="TTL-form-label">列表页可退订时间（天）</label>
                <wcinput 
                    :option="{title:'请填写退订时间',type:'input',width:'100%',isinput:true}" 
                    :value="refundinfo.listtopend"  
                    @finish="(val)=> {
                        this.refundinfo.listtopend=val.value;
                    }"
                />
            </el-form-item>
            <el-form-item>
                <label class="TTL-form-label">退款金额</label>
                <wcinput 
                    :option="{title:'请填写退款金额',type:'input',width:'100%',isinput:true}" 
                    :value="refundinfo.end_price"  
                    @finish="(val)=> {
                        this.refundinfo.end_price=val.value;
                    }"
                />
            </el-form-item>
        </el-form>
        <div class="er-btn-list top20">
            <wcbutton :option="{title:'取消',type:'del'}" @finish="(val)=> {this.handleClose()}" />
            <wcbutton :option="{title:'确定'}" @finish="(val)=> {this.refundRenew()}" class="left10"/>
        </div>
    </el-dialog>
</template>

<script>
import INTERFACE_MODEL_RENEW from '@/Interface/Es/Renew';
export default {
    props:['view','value'],
    data() {
        return {
            logview:false,
            id:'',
            refundinfo:{},
        }
    },
    watch: {
        view(val){
            if(val) {
                this.logview=true;
                this.id=this.value;
                this.GetRenewRefundInfo(this.id);
            }
        },
    },
    mounted() {
        
    },
    methods: {


        /** 获取商品退款信息 **/
        GetRenewRefundInfo(id) {
            INTERFACE_MODEL_RENEW.GET_RENEW_DETAIL_GOODS_TOP({id:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.refundinfo=res.data;
            });
        },


        /** 关闭窗口 **/
        handleClose() {
            this.logview=false;
            this.$emit('finish');
        },

        /** 提交退订信息 **/
        refundRenew() {
            INTERFACE_MODEL_RENEW.GOODS_RENEW_REFUND(this.refundinfo).then((res) => {
                 if(res.status > 0) return false;
                 this.handleClose();
            });
        },

    },
}
</script>
<style scoped>
.auth-box {display: inline-block;width:100%;}
.auth-box-item {display: inline-flex;align-items: center;width:100%;position:relative;}
.auth-title {display: inline-flex;align-items: center;font-size:16px;font-weight: bold;}
.auth-title span {font-size:12px;line-height: 12px;color:#666666;padding:4px 10px;border-radius: 20px;border:1px solid #666666;font-weight: normal;}
.auth-status {color:#ffffff !important;background-color: #666eeb;border-color:#666eeb !important;}
.auth-box-content-title {display: inline-block;font-size:13px;color:#333333;width:25%;}
.auth-box-content {display: inline-block;font-size:13px;color:#333333;}
.auth-error {font-size:13px;color:red !important;border:none !important;}
.TTL-btn-box {display: inline-flex;justify-content: flex-end;align-items: center;width:100%;margin-bottom:20px;}
.er-renew-goods-title {display: inline-block;width:100%;font-size:16px;font-weight: bold;color:#333333;}
.er-btn-list {display: inline-flex;width:100%;justify-content: flex-end;align-items:center;}
</style>